import React, { Component } from "react";
import { connect } from "react-redux";
import { withRouter } from "../../../utils/withRouter";
import {timeslot_list_action,timeslot_delete_action
} from "../../../actions/master_actions/timeSlot_action";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import Loader from "../../../utils/Loader";
import { StatusActionId, sessionExpireMessage, tokenInavlidMessage } from "../../../utils/constants";
import { fill_action } from "../../../actions/fillList_action";
import Header from "../../../common_components/Header";
import Pagination from "../../../utils/pagination";
class timeSlotList extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      userId: "",
      TimeSlotID: "",
      TimeSlotName: "",
      StatusID: "",
      FromTime: "",
      ToTime: "",
      SelectedHrs:"",
      Description:"",
      slotList: [],
      statusFillList: [],
      isAccordionExpanded: false,
      currentPage: 1,
    };
    this.navigateSlotAdd = this.navigateSlotAdd.bind(this);
    this.getSlotsList = this.getSlotsList.bind(this);
    this.navigateSlotUpdate = this.navigateSlotUpdate.bind(this);
    this.updateItem = this.updateItem.bind(this);
  }
  componentDidMount() {
    if (JSON.parse(sessionStorage.getItem("UserLoginData")) == null) {
      console.log("log");
      setTimeout(() => {
        this.props.navigate("/login");
      }, 500);
    }
    setTimeout(() => {
      {
        sessionStorage.getItem("roleId") == 4 ? (
          this.props.navigate("/checkList")
        ) : (
          <></>
        );
      }
    }, 10);
    const { userId } = this.state;
    this.setState({
      userId:
        sessionStorage.getItem("userId") == "" ||
        sessionStorage.getItem("userId") == null
          ? ""
          : sessionStorage.getItem("userId"),
    });
    this.getSlotsList();
    this.getFillList(StatusActionId, userId, "", "");
  }

  navigateSlotUpdate(TimeSlotID, StatusID) {
    console.log(TimeSlotID, StatusID);
    this.props.navigate("/timeSlotAU", {
      state: { TimeSlotID: TimeSlotID, StatusID: StatusID },
    });
  }

  navigateSlotAdd() {
    this.props.navigate("/timeSlotAU");
  }

  getFillList(value, userId, keyword, keyvalue) {
    this.setState({ isLoading: true });
    this.props
      .fill_action(
        value,
        userId == "" || userId == null ? null : userId,
        keyword != "" ? keyword : null,
        keyvalue != "" ? keyvalue : null
      )
      .then((data) => {
        if (data.error != 1) {
          if (value == StatusActionId) {
            this.setState({ statusFillList: data.data, isLoading: false });
            console.log(data.data, "status");
          }
        }
      })
      .catch((e) => {
        console.log(e);
      });
  }
  getSlotsList = async () => {
    const { userId, TimeSlotName,FromTime,ToTime, StatusID } = this.state;
    this.setState({ isLoading: true });

    const finalStatus = StatusID == "InActive" ? 0 : StatusID=="Active"?1:null;
    this.props
      .timeslot_list_action(TimeSlotName,FromTime,ToTime,finalStatus)
      .then((data) => {
        console.log(data);
        if (data.error !== 1) {
         
          this.setState({
            slotList: data.data,
            isLoading: false,
            currentpage: 1,
          });
        } else {
          if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
            //after session expire.....................
            sessionStorage.clear()
            this.props.navigate('/normalView')
            setTimeout(() => {
              toast.error(data.msg, {
                position:"top-center",
                theme: "colored",
                autoClose: 3000,
                hideProgressBar: true,
              });
            }, 500);
        }else{
          toast.error(data.msg, {
            position:"top-center",
            theme: "colored",
            autoClose: 3000,
            hideProgressBar: true,
          });
        }}
      })
      .catch((e) => {
        console.log(e);
      });
    setTimeout(() => {
      console.log(this.state.slotList);
    }, 500);
  };

  handleDelete(TimeSlotID) {
    const { userId } = this.state;
    const confirmed = window.confirm(
      "Are you sure you want to delete this Time Slot?"
    );

    if (confirmed) {
      this.props
        .timeslot_delete_action(TimeSlotID)
        .then((data) => {
          if (data.error !== 1) {
            toast.success("Data Deleted Successfully", {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
            this.getSlotsList(); // Refresh the holiday list after deletion
          } else {
            if(data.msg == sessionExpireMessage || data.msg == tokenInavlidMessage){
              //after session expire.....................
              sessionStorage.clear()
              this.props.navigate('/normalView')
              setTimeout(() => {
                toast.error(data.msg, {
                  position:"top-center",
                  theme: "colored",
                  autoClose: 3000,
                  hideProgressBar: true,
                });
              }, 500);
          }else{
            toast.error(data.msg, {
              position:"top-center",
              theme: "colored",
              autoClose: 3000,
              hideProgressBar: true,
            });
          }}
        })
        .catch((e) => {
          console.log(e);
        });
    }
  }
  updateItem(item) {
    this.setState({ currentPage: item });
  }
  slotRecord(slotList) {
    // const { userList } =this.state
    return (
      <table
        className="table table-bordered table-striped"
        id="dashboard-table"
      >
        <thead>
          <tr>
            <th class="text-center" style={{ width: "10%" }}>
              Sr No.
            </th>
            <th style={{ width: "20%" }}>Slot Name</th>
            <th style={{ width: "20%" }}>From Time</th>
            <th style={{ width: "20%" }}>To Time</th>
            <th class="text-center"  style={{ width: "10%" }}>Selected Hrs</th>
            <th class="text-center" style={{ width: "10%" }}>
              Status
            </th>
            <th className="text-center" style={{ width: "10%" }}>
              Action
            </th>
          </tr>
        </thead>
        <tbody id="myTable">
          {slotList != "" && slotList != null ? (
            slotList.map((item,i) => (
              <tr>
                <td class="text-center">{i+1}</td>
                <td>{item.TimeSlotName}</td>
                <td>{item.FromTime}</td>
                <td>{item.ToTime}</td>
                <td class="text-center">{item.SelectedHr}</td>
                <td class="text-center">
                  {item.StatusID == 1 ? "Active" : "Inactive"}
                </td>
                <td class="text-center">
                  <a
                    href="javascript:void(0);"
                    onClick={() =>
                      this.navigateSlotUpdate(
                        item.TimeSlotID,
                        item.StatusID
                      )
                    }
                    title="Edit"
                    className="btn btn-sm"
                  >
                    <i className="fa fa-edit action_btn_table" />
                  </a>
                  {item.StatusID==1?(

                    <a
                    title="Delete"
                    className="btn btn-sm delete_record"
                    onClick={() => this.handleDelete(item.TimeSlotID)}
                    >
                    <i className="fa fa-trash action_btn_table" />
                  </a>
                  ):<></>}
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="8">No data available</td>
            </tr>
          )}
        </tbody>
      </table>
    );
  }

  render() {
    const {
      isLoading,
      slotList,
      isAccordionExpanded,
      statusFillList,
      currentPage,
    } = this.state;
    const recordsPerPage = 10;
    const indexOfLastRecord = currentPage * recordsPerPage;
    const indexOfFirstRecord = indexOfLastRecord - recordsPerPage;
    // Records to be displayed on the current page
    const currentRecords = slotList.slice(
      indexOfFirstRecord,
      indexOfLastRecord
    );
    const nPages = Math.ceil(slotList.length / recordsPerPage);
    return (
      <>
        {isLoading ? <Loader></Loader> : null}
        <>
          <main id="main">
            <Header data={[21]} />

            <section style={{ marginTop: 115 }}>
              <div className="container-fluid">
                <div className="page-header">
                  <h4 className="page-title">List of Time Slot</h4>
                  <div>
                    <a
                      href="javascript:void(0);"
                      onClick={() => this.navigateSlotAdd()}
                      className="btn btn-primary btn-sm create_btn"
                    >
                      <span className="hidden-xs">Add</span>
                    </a>
                  </div>
                </div>
                <div className="search_accordion search_card">
                  <div className="panel-group" id="accordion">
                    <div className="panel panel-default">
                      <div
                        className="panel-heading accordion-toggle collapsed"
                        data-toggle="collapse"
                        data-parent="#accordion"
                        data-target="#collapseOne"
                        aria-expanded={isAccordionExpanded}
                        onClick={() =>
                          this.setState({
                            isAccordionExpanded: !isAccordionExpanded,
                          })
                        }
                      >
                        <h4 className="panel-title">Search:</h4>
                        <div className="searched_items">
                          <h5>
                            Slot Type : <span>{this.state.Name}</span>
                          </h5>
                          <h5>
                            Status : <span>{this.state.StatusID}</span>
                          </h5>
                        </div>
                      </div>
                      <div
                        id="collapseOne"
                        className={`panel-collapse collapse ${
                          isAccordionExpanded ? "show" : ""
                        }`}
                        aria-labelledby="headingOne"
                      >
                        <div className="panel-body">
                          <div className="row mr_0">
                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Slot Type</label>
                                <input
                                  type="text"
                                  value={this.state.Name}
                                  onChange={(e) =>
                                    this.setState({ Name: e.target.value })
                                  }
                                  className="form-control search_form_control"
                                  placeholder="Enter Slot Type"
                                />
                              </div>
                            </div>

                            <div className="col-md-2">
                              <div className="form-group">
                                <label>Status</label>
                                <select
                                  className="form-control"
                                  value={this.state.StatusID}
                                  onChange={(e) =>
                                    this.setState({ StatusID: e.target.value })
                                  }
                                >
                                  <option selected={this.state.StatusID==null}>Select Status</option>
                                  {statusFillList.length > 0
                                    ? statusFillList.map((data) => (
                                        <option
                                          key={data.Status}
                                          value={data.Status}
                                        >
                                          {data.Status}
                                        </option>
                                      ))
                                    : null}
                                </select>
                              </div>
                            </div>
                            <div className="col-md-4">
                              <label>&nbsp;</label>
                              <button
                                onClick={() => this.getSlotsList()}
                                className="btn btn-primary search_btn"
                              >
                                Search
                              </button>
                              &nbsp;
                              <button
                                onClick={() => {
                                  this.setState(
                                    {
                                      StatusID: null,
                                      Name: "",currentPage:1
                                    },
                                    () => this.getSlotsList()
                                  );
                                }}
                                className="btn btn-primary search_btn"
                              >
                                Clear Filters
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="custom_table">
                  <div className="hack1">
                    <div className="hack2">
                      {this.slotRecord(currentRecords)}
                      {slotList.length > 0 ? (
                        <Pagination
                          nPages={nPages}
                          currentPage={currentPage}
                          setCurrentPage={this.updateItem}
                        />
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </main>
         
          <ToastContainer />
        </>
      </>
    );
  }
}
export default withRouter(
  connect(null, {timeslot_list_action,timeslot_delete_action,
    fill_action,
  })(timeSlotList)
);
